import { defineMessages } from 'react-intl';

export const formMessages = defineMessages({
	invalid_message: {
		id: 'form.invalid_message',
		defaultMessage: 'Invalid message',
		description:
			'"Invalid message" text placed in textarea/preview box when a there are errors in the internal message data',
	},
	placeholder: {
		id: 'form.placeholder',
		defaultMessage: 'Write your message here...',
		description:
			'placeholder text placed in textarea when there are no message inside',
	},
	input_locked: {
		id: 'form.input_locked',
		defaultMessage:
			'You cannnot send message right now. Please complete the request first',
		description:
			'this text will appears when there is a required form/flow to complete',
	},
	closed__start_new: {
		id: 'form.start_new',
		defaultMessage: 'Start a new chat',
		description:
			'Button text to start a new chat after closing the current one',
	},
});
